import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "@/lib/data";

function Counter({ value, suffix, raw }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  useEffect(() => {
    if (!inView || raw) return;
    let start = 0;
    const duration = 1600;
    const startTime = performance.now();
    const step = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      start = Math.floor(eased * value);
      setDisplay(start);
      if (p < 1) requestAnimationFrame(step);
      else setDisplay(value);
    };
    requestAnimationFrame(step);
  }, [inView, value, raw]);

  return (
    <span ref={ref}>
      {raw ? raw : display.toLocaleString("tr-TR") + (suffix || "")}
    </span>
  );
}

export default function Stats() {
  return (
    <section id="stats" className="border-y border-ink/5 bg-cloud" data-testid="stats">
      <div className="mx-auto grid max-w-[1440px] grid-cols-2 gap-x-6 gap-y-12 px-6 py-16 md:grid-cols-4 md:px-[100px] md:py-20">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className="flex flex-col items-center text-center md:items-start md:text-left"
            data-testid={`stat-${i}`}
          >
            <div className="text-4xl font-extrabold tracking-tight text-ink md:text-5xl lg:text-6xl">
              <Counter {...s} />
            </div>
            <div className="mt-2 h-1 w-10 rounded-full bg-orange" />
            <p className="mt-3 text-sm font-medium text-ink/60 md:text-base">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
